module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/00d700a6397f85c7d4c48bdf4ece20cbc85fea12f55a-En0Urw_fw1200_1@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2F00d700a6397f85c7d4c48bdf4ece20cbc85fea12f55a-En0Urw_fw1200_1%402x.png
// module id = W9R9
// module chunks = 93